export default __webpack_public_path__ + "static/media/gretaList.78e0cc92.png";